import React, { useState, useEffect } from 'react';
import '../../css/style.css';

export function ValidationMessages({ messages, onClose }) {
    const [, setVisible] = useState(true);
    const [closing, setClosing] = useState(false);

    useEffect(() => {
        if (messages.length === 0) return;

        const timer = setTimeout(() => {
            setClosing(true);
            setTimeout(() => {
                setVisible(false);
                if (onClose) onClose();
            }, 500);
        }, 5000);

        return () => clearTimeout(timer);
    }, [messages, onClose]);

    // Ensure messages is always an array before rendering
    const messageArray = Array.isArray(messages) ? messages : [messages];

    if (messageArray.length === 0) return null;

    return (
        <div className={`alert-box row ${closing ? 'closing' : ''}`} style={{ zIndex: 2000, position: 'fixed' }}>
            <div className="relative p-4 mb-4" style={{ backgroundColor: '#FFEEEE' }}>
                <div
                    className="alert-close"
                    onClick={() => {
                        setClosing(true);
                        setTimeout(() => {
                            setVisible(false);
                            if (onClose) onClose();
                        }, 500);
                    }}
                >
                    <span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
                </div>
                <ul className="list-none m-0 p-0">
                    {messageArray.map((error, index) => {
                        // If the error is an object, extract the message property
                        const errorMessage = typeof error === 'object' && error.message ? error.message : error;

                        return (
                            <div key={index}>
                                <span className="glyphicon glyphicon-exclamation-sign" style={{ marginRight: 10, marginTop: 10, marginBottom: 10, color: "red" }}></span>
                                <span style={{ color: "red" }}>{errorMessage}</span>
                            </div>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
